export var getDefaultStyleSheet = () => ({
  rootStyle: {
    flexDirection: 'row'
  }
});
//# sourceMappingURL=getDefaultStyleSheet.js.map